import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { DentalAttendance } from "@/@types/esus/DentalAttendance";

type IndicatorEmultiM2DentalAttendanceHistoryItemProps = {
	dentalAttendance: DentalAttendance;
};

export function IndicatorEmultiM2DentalAttendanceHistoryItem({
	dentalAttendance,
}: Readonly<IndicatorEmultiM2DentalAttendanceHistoryItemProps>) {
	return (
		<>
			<Row>
				<Col>
					<p>
						<span className="fw-bold text-primary">Equipe: </span>
						{dentalAttendance.healthTeam1?.name ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="fw-bold text-primary">Unidade: </span>
						{dentalAttendance.healthUnit1?.name ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="text-primary">Profissional: </span>
						{dentalAttendance.professional1?.name ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="text-primary">Categoria: </span>
						{dentalAttendance.cbo1?.description?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			{dentalAttendance.healthTeam2 &&
				dentalAttendance.healthTeam2.id !== 1 &&
				dentalAttendance.healthUnit2 &&
				dentalAttendance.healthUnit2.id !== 1 &&
				dentalAttendance.professional2 &&
				dentalAttendance.professional2.id !== 1 &&
				dentalAttendance.cbo2 &&
				dentalAttendance.cbo2.id !== 1 && (
					<>
						<Row>
							<Col>
								<p>
									<span className="fw-bold text-primary">
										Equipe secundária:{" "}
									</span>
									{dentalAttendance.healthTeam2?.name.toUpperCase() ?? "N/A"}
								</p>
							</Col>
							<Col>
								<p>
									<span className="fw-bold text-primary">
										Unidade secundária:{" "}
									</span>
									{dentalAttendance.healthUnit2?.name.toUpperCase() ?? "N/A"}
								</p>
							</Col>
						</Row>
						<Row>
							<Col>
								<p>
									<span className="text-primary">Profissional secundário: </span>
									{dentalAttendance.professional2?.name.toUpperCase() ?? "N/A"}
								</p>
							</Col>
							<Col>
								<p>
									<span className="text-primary">
										Categoria do profissional secundário:{" "}
									</span>
									{dentalAttendance.cbo2?.description?.toUpperCase() ?? "N/A"}
								</p>
							</Col>
						</Row>
					</>
				)}
		</>
	);
}
